/**
@format
@flow
*/
import * as React from 'react';
import Colors from '@ziynx/theme/colors';
import { Body as KrispyBody } from '@krispy/typography/web';

type Props = $ReadOnly<{|
  /**
   * Extra large font size
   */
  extraLarge?: boolean,

  /**
   * Large font size
   */
  large?: boolean,

  /**
   * Medium font size
   */
  medium?: boolean,

  /**
   * Small font size
   */
  small?: boolean,

  /**
   * extraSmall font size
   */
  extraSmall?: boolean,

  /**
   * Color for body text
   */
  color?: string,

  /**
   * Primitive types
   */
  primitive?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',

  /**
   * Text
   */
  children: any,

  /**
   * Animated bool to trigger a transition
   */
  animated?: boolean,
|}>;

/**
 * Body component
 */
const Body = (props: Props): React$Node => {
  const {
    color, animated, children, ...rest
  } = props;

  return (
    <KrispyBody color={color} animated={animated} {...rest}>
      {children}
    </KrispyBody>
  );
};

Body.defaultProps = {
  color: Colors.GrayVeryDark,
  animated: false,
  primitive: 'p',
};

export default Body;
